import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'lucide-react';
import './button.css';

const PrimaryButton = ({ onClick, text, icon: Icon, width, height, color, isLoading }) => {
    const isRTL = document.body.dir === "rtl"
    const buttonStyle = {
        display: "flex",
        width: width || "88px",
        height: height || "32px",
        backgroundColor: color || '#007B4E',
        whiteSpace: "nowrap",
        flexDirection: isRTL ? "row-reverse" : "row"
    };

    return (
        <button
            onClick={onClick}
            className={`primary-button ${isLoading ? 'loading' : ''}`}
            style={buttonStyle}
            disabled={isLoading}
        >
            {isLoading ? (
                <Loader size={16} className="animate-spin" />
            ) : (
                <>
                    {Icon && <Icon size={16} className="primary-button-icon" />}
                    <span>{text}</span>
                </>
            )}
        </button>
    );
};

PrimaryButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    icon: PropTypes.elementType,
    width: PropTypes.string,
    height: PropTypes.string,
    color: PropTypes.string,
    isLoading: PropTypes.bool,
};

export default PrimaryButton;
